import React from "react";
import { Link } from "react-router-dom";

function Safe() {
  return (
    <div>
      <section
        className="page-title"
        style={{
          backgroundImage: "url(../images/background/bg-page-title-1.jpg)",
        }}
      >
        <div className="auto-container">
          <h1>스마트 서비스</h1>
          <div className="bread-crumb-outer">
            <ul className="bread-crumb clearfix">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li className="active">안전 플랫폼</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="feature-style-1">
        <div className="auto-container">
          <div className="row clearfix">
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 company">
              <div className="company-tab">
                <ul className="nav nav-pills nav-justified">
                  <li>
                    <Link data-toggle="pill" to="/smartcity">
                      스마트시티서비스{" "}
                    </Link>
                  </li>
                  <li className="active">
                    <Link data-toggle="pill" to="/safe">
                      안전 플랫폼{" "}
                    </Link>
                  </li>
                  <li>
                    <Link data-toggle="pill" to="/sims">
                      SIMS{"  "}
                    </Link>
                  </li>
                </ul>
                <div className="tab-content">
                    <div className='tab_content_area'>
                        <div className="tab_title">
                            안전 플랫폼
                        </div>
                        <div className='tab_paragraph'>
                            <p>개요</p>
                            <div className='tab_brackets'></div>
                                <ul>
                                    <li>- 도시 재해재난 발생 시 재난정보를 수집하고 분석·예측하여 시민들에게 데이터 기반의 재해재난 대응 서비스 제공</li>
                                    <li>- 빅데이터 기반의 데이터 공유형 안전 플랫폼을 개발하여 데이터를 수집, 분석하고, 전용 모바일 앱을 통해 상황 전파</li>
                                </ul>
                        </div>
                        <div className='tab_paragraph'>
                            <p>특장점</p>
                            <div className='tab_brackets'></div>
                                <ul>
                                    <li>- 안전분야 대상별 (경사지 붕괴, 폭염, 화재, 홍수) 데이터를 시스템간 연계하여 종합 관리하는 플랫폼 구축</li>
                                    <li>- 안전 플랫폼 및 모바일 앱의 슬림(Slim)화, 모듈(Module)화, 라이트(Light)화하여 안전분야 최적의 성능 제공</li>
                                    <li>- 다양한 센서로부터 수집되는 데이터 기반 자가학습 패턴인식 기술 제공</li>
                                    <li>- REST, Socket.IO, JSON 등 웹 기술을 활용한 표준 연계 인터페이스 제공</li>

                                </ul>
                        </div>
                        <div className='tab_paragraph'>
                            <p>서비스 구성</p>
                            <div className='tab_brackets'></div>
                            <img src='./images/service/Data/image34.png' alt='' style={{width:'100%'}}/>
                        </div>
                        <div className='tab_paragraph'>
                            <p>개발 S/W 화면</p>
                            <div className='tab_brackets'></div>
                            <div className='servicePostBox5'>
                                    <div  className='servicePostCard6'>
                                            <img src='./images/service/Data/image36.png' alt=''/><br/>
                                            <b style={{whiteSpace:'nowrap'}}>안전 플랫폼 대시 보드 화면</b>
                                    </div>
                                    <div  className='servicePostCard6'>
                                            <img src='./images/service/Data/image37.png' alt=''/><br/>
                                            <b style={{whiteSpace:'nowrap'}}>안전 플랫폼 GIS 기반 예·경보 현황</b>
                                    </div>
                                    <div  className='servicePostCard6'>
                                            <img src='./images/service/Data/image35.png' alt=''/><br/>
                                            <b style={{whiteSpace:'nowrap', paddingLeft:'60px',paddingRight:'40px'}}>시각화 데이터</b>
                                    </div>
                                    <div  className='servicePostCard6'>
                                            <img src='./images/service/Data/image38.png' alt=''/><br/>
                                            <b style={{whiteSpace:'nowrap'}}>구호 부서 출동 최적 경로 선정</b>
                                    </div>
                            </div>
                        </div>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
export default Safe;
